import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import styled from 'styled-components';

const AutocompleteContainer = styled.div`
  min-width: 160px;
  max-width: 180px;
  
  .MuiAutocomplete-root {
    .MuiOutlinedInput-root {
      height: 36px;
      padding: 0 8px;
      
      .MuiOutlinedInput-input {
        padding: 8px 4px;
        font-size: 14px;
      }
      
      .MuiAutocomplete-endAdornment {
        right: 8px;
      }
    }
    
    .MuiInputLabel-root {
      font-size: 13px;
      transform: translate(12px, 8px) scale(1);
      
      &.MuiInputLabel-shrink {
        transform: translate(12px, -6px) scale(0.75);
      }
    }
  }
`;

const NavigationInputs = ({ 
  pages = [], 
  pageId, 
  maskId, 
  onPageIdChange, 
  onMaskIdChange 
}) => {
  return (
    <>
      <AutocompleteContainer>
        <Autocomplete
          size="small"
          options={pages.map(p => ({ 
            label: p.pageId.toString(), 
            value: p.pageId
          }))}
          getOptionLabel={(option) => option.label}
          value={pages.find(p => p.pageId == pageId) ? { 
            label: pageId.toString(), 
            value: pageId
          } : null}
          onChange={(event, newValue) => {
            if (newValue && onPageIdChange) {
              onPageIdChange(newValue.value);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Page ID"
              variant="outlined"
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  '&:hover': {
                    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                  },
                  '&.Mui-focused': {
                    boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)',
                  }
                }
              }}
            />
          )}
        />
      </AutocompleteContainer>

      <AutocompleteContainer>
        <Autocomplete
          size="small"
          options={pages.map(p => ({ 
            label: p.NumberMasked || p.pageId?.toString() || '', 
            value: p.NumberMasked || p.pageId?.toString() || ''
          }))}
          getOptionLabel={(option) => option.label}
          value={pages.find(p => (p.NumberMasked || p.pageId?.toString()) === maskId) ? { 
            label: maskId, 
            value: maskId
          } : null}
          onChange={(event, newValue) => {
            if (newValue && onMaskIdChange) {
              onMaskIdChange(newValue.value);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Number Mask"
              variant="outlined"
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  '&:hover': {
                    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                  },
                  '&.Mui-focused': {
                    boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)',
                  }
                }
              }}
            />
          )}
        />
      </AutocompleteContainer>
    </>
  );
};

export default NavigationInputs;
